import React from 'react';
import ResourceLinks from 'gatsby-theme-carbon/src/components/LeftNav/ResourceLinks';
import env from '../../../env';

const linksInteral = [
  {
    title: 'Git Repo',
    href:
      'https://github.ibm.com/maximo-app-framework/maximo-restapi-documentation',
  }
];

const linksPublic = [];

let links = (env.internalOnly) ? linksInteral : linksPublic;

// shouldOpenNewTabs: true if outbound links should open in a new tab
const CustomResources = (props) => {
  return <ResourceLinks {...props} shouldOpenNewTabs links={links} />
};

export default CustomResources;
